// extracted by mini-css-extract-plugin
module.exports = {"container":"SettingTermsTypeCell_container__1yvqQ","txt":"SettingTermsTypeCell_txt__38Qlg"};